<div id="alta-remax-container">
  <p class="heading-02-semi-bold">
    Se procederá a solicitar el alta Re/Max. <br />
    <br />
    ¿Desea continuar?
  </p>
</div>
